WiseMetering.Model.Address = WiseMetering.Model.extend({

    urlRoot: '/addresses'

});
